import { render, staticRenderFns } from "./ReviewFlowDetail.vue?vue&type=template&id=3fd756ac&"
import script from "./ReviewFlowDetail.vue?vue&type=script&lang=js&"
export * from "./ReviewFlowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports